import React from "react";
import Title from "./Title"; // Adjust the import path as needed

// Common Styles
const containerStyle = {
  backgroundColor: "red",
  backgroundSize: "cover",
  borderRadius: 12,
  margin: "0.5rem",
  padding: "8px 0px",
  position: "relative",
  zIndex: 10,
  width: "auto",
  height: "auto",
  display: "block",
  cursor: "pointer",
};

const overlayStyle = {
  position: "absolute",
  zIndex: 15,
  top: 0,
  left: 0,
  opacity: 0.5,
  borderRadius: 12,
  background: "linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.2))",
  width: "100%",
  height: "175px",
};

const titleContainerBaseStyle = {
  position: "absolute",
};

// Banner Component
function Banner({ language, title, imageUrl, height = 175, callback }) {
  const containerWithBackground = {
    ...containerStyle,
    background: `url('${imageUrl}') no-repeat center center`,
    height: height,
    minWidth: "260px",
  };

  const overlayStyleWithHeight = {
    ...overlayStyle,
    height: height,
  };
  const titleContainerStyle = {
    ...titleContainerBaseStyle,
    textAlign: language === "arabic" ? "right" : "left",
    bottom: 5,
  };

  return (
    <div style={containerWithBackground} onClick={callback ? () => callback() : () => console.log("no callback")}>
      <div style={titleContainerStyle}>
        <Title title={"This"} />
      </div>
      <div style={overlayStyleWithHeight}></div>
    </div>
  );
}

export default Banner;
